export default {
  labels: {
    dont_have_account: "Vous n'avez pas de compte ? ",
  },
  title: 'Rejoignez {{name}} !',
  default_program_name: 'Club de récompenses',
  buttons: {
    sign_up: "S'inscrire",
  },
};
